import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 460px;
	padding: 30px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
`;

const StyledContent = styled.div`
	position: relative;
`;

export { StyledContainer, StyledContent };
